import useFetchCd from 'hooks/useFetchCd';
import React, { useState } from 'react'
import StarSvg from "../../../assets/svgs2026/starIconSvg.svg"
import { formatDateToDDMMYYYY, formatDecimalToCSV } from 'utlis/utils';
import LiquidGlassButton from 'components/LiquidGlassButton';
import { OverlayLoader } from 'components/core';

const CDBalandeForRM = () => {

    const { loading: cdLoading, cdDetail } = useFetchCd({ presist: true });

    const cdBalanceNavigator = (redirectionLink) => {
        if (redirectionLink) {
            window.open(redirectionLink, "_blank")
        }
    }

    return (
        <div>
            {!cdDetail ? <OverlayLoader /> : <>
                {/* CD Balance */}
                {/* <div
                style={{
                    marginBottom: "21px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                }}
            >
                <span className="overview-main-header-css">CD Balance</span>
                <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                    <img src={StarSvg} alt="StarSvg" />
                    <div className="starLineCss" style={{ width: "100%" }} />
                </div>
            </div> */}
                <div className="cd-balance-cards-grid">
                    {Object.keys(cdDetail).map((eachBalance) => (
                        <>
                            <div
                                class="cd-balance-card"
                                onClick={() =>
                                    cdBalanceNavigator(
                                        cdDetail[eachBalance].cd_balance_statement_url,
                                    )
                                }
                            >
                                <div class="spacing-css">
                                    <div>
                                        <span className="cd-balance-heading-css">
                                            {cdDetail[eachBalance].service_provider_name}
                                        </span>
                                    </div>
                                    <div className="gold-line-css" />
                                </div>

                                <span className="cd-balance-card-sub-heading">
                                    {cdDetail[eachBalance]?.last_updated_date ? (
                                        <>
                                            {"as on"}{" "}
                                            {formatDateToDDMMYYYY(
                                                cdDetail[eachBalance]?.last_updated_date,
                                            )}
                                        </>
                                    ) : (
                                        "--"
                                    )}
                                </span>

                                <div
                                    style={{
                                        marginTop: "22px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span className="cd-balance-card-footer">
                                        ₹
                                        {cdDetail[eachBalance].balance_amount
                                            ? formatDecimalToCSV(cdDetail[eachBalance].balance_amount)
                                            : 0}
                                    </span>

                                    <div
                                        onClick={() =>
                                            cdBalanceNavigator(
                                                cdDetail[eachBalance].cd_balance_statement_url,
                                            )
                                        }
                                    >
                                        <LiquidGlassButton />
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}
                </div>
            </>}
        </div>
    )
}

export default CDBalandeForRM
